enum DefaultPaymentCodes {
  CAD = 'CAD',
  CA = 'CA',
}

export const DEFAULT_PAYMENT_CURRENCY = DefaultPaymentCodes.CAD;
export const DEFAULT_PAYMENT_COUNTRY = DefaultPaymentCodes.CA;
